import type { TripStopLocation } from 'contracts/transport-routes';

export function generateLocationName (location: TripStopLocation) {
  const { type, lat, lng, city_name, uf } = location;
  return type === 'city'
    ? [city_name, uf].filter(Boolean).join('/')
    : [lat, lng].filter(Boolean).join('/');
}